import * as Device from 'expo-device';
import { Platform } from 'react-native';

import { supabase } from '@/lib/supabase';

async function fetchClientIp(): Promise<string> {
  try {
    const { data } = await supabase.functions.invoke('get-client-ip');
    return (data as { ip: string })?.ip ?? 'unknown';
  } catch {
    return 'unknown';
  }
}

function getDeviceInfo(): Record<string, string | null> {
  return {
    platform: Platform.OS,
    model: Device.modelName,
    osVersion: Device.osVersion,
  };
}

export async function recordSigningEvent(
  agreementId: string,
  signerId: string,
  verificationMethod: 'none' | 'phone' | 'id' = 'none',
): Promise<void> {
  const [ip] = await Promise.all([fetchClientIp()]);

  await supabase.from('signing_events').insert({
    agreement_id: agreementId,
    signer_id: signerId,
    ip_address: ip,
    device_info: getDeviceInfo(),
    verification_method: verificationMethod,
  });
}

export type SigningMeta = {
  signer_id: string;
  signed_at: string;
  ip_address: string | null;
  device_info: Record<string, string | null> | null;
  verification_method: string;
};

export async function fetchSigningEvents(agreementId: string): Promise<SigningMeta[]> {
  const { data, error } = await supabase
    .from('signing_events')
    .select('signer_id, signed_at, ip_address, device_info, verification_method')
    .eq('agreement_id', agreementId)
    .order('signed_at', { ascending: true });

  if (error) throw error;
  return (data ?? []) as SigningMeta[];
}
